import { toJS } from "mobx";
import OptimizationStore from "../store/OptimizationStore";
import AuthStore from "../../login/store/AuthStore";
import generateGetRecoApiRequest from "./generateGetRecoApiRequest";

const generateBasicDataStructure = () => {
  if (AuthStore.journeyData && Object.keys(AuthStore.journeyData).length > 0) {
    const journeyData = toJS(AuthStore.journeyData);
    let {
      family_details_list,
      family_product_details_list,
      journey_details,
      journey_need,
    } = journeyData;
  
    let riskList = [];
    let productWiseRiskList = [];
    if (journey_details.high_risk_selected) riskList.push("high");
    riskList = [...riskList, ...["medium", "low"]];
    riskList.forEach((item) => {
      productWiseRiskList.push({
        risk: item,
        BI: {},
        bi_request: {},
        update_BI: false,
      });
    });
  
    let dataStructure = [];
    family_product_details_list.forEach((item) => {
      if (item.is_selected) {
        let isRemoved = journey_need.find(
          (needData) => needData.need === item.need
        );
  
        let laDetails = family_details_list.find(
          (familyData) => familyData.id === item.family
        );
        let prDetails = family_details_list.find(
          (familyData) => familyData.id === item.proposer_family
        );
        
        let secondaryLaDetails = family_details_list.find(
          (familyData) => familyData.id === item.secondary_la
        );
        let needDetails = {};
  
        let dataObj = {
          BI:
            item.need_unique_name === "protection_for_my_family"
              ? { risk: "high", BI: {}, bi_request: {}, update_BI: false }
              : productWiseRiskList,
          dob: laDetails.dob,
          family_member_type: laDetails.family_member_type,
          gender: laDetails.gender,
          id: laDetails.id,
          income_type: laDetails.income_type,
          isSelected: true,
          monthly_income: laDetails.monthly_income,
          payout_mode: item.payout_mode,
          life_assured_details: laDetails,
          proposer_details: prDetails,
          secondary_la_Details:secondaryLaDetails,
          family_product_id: item.id,
        };
        if (
          dataStructure.some(
            (structureData) =>
              structureData.need_unique_name === item.need_unique_name
          )
        ) {
          dataStructure.forEach((structureData) => {
            if (structureData.need_unique_name === item.need_unique_name) {
              structureData.data.push(dataObj);
            }
          });
        } else {
          needDetails.need_unique_name = item.need_unique_name;
          needDetails.need_title = item.need_name;
          needDetails.is_removed = isRemoved.is_removed;
          needDetails.isDisabledNeed = isRemoved.is_removed;
          needDetails.productDisabled = item?.la_removed || false;
          needDetails.data = [dataObj];
          dataStructure.push(needDetails);
        }
      }
    });
    OptimizationStore.product_list_data = dataStructure;
    generateGetRecoApiRequest();

  } else {
   
    console.error("Journey data is empty or undefined.");
    
  }
  const journeyData = toJS(AuthStore.journeyData);
  
};

export default generateBasicDataStructure;
